import { createAction } from 'redux-actions';

import {
	USER_LOGOUT,
	SPINNER_SHOW,
	SPINNER_HIDE,
	RESET_ERRORS,
	CREATE_ERROR,
	RESET_APPLICATION_STATE
} from './constants';

export const logoutUser = createAction(USER_LOGOUT, (callback) => ({
	callback
}));

export const showSpinner = createAction(SPINNER_SHOW);

export const hideSpinner = createAction(SPINNER_HIDE);

export const createError = createAction(CREATE_ERROR, (error) => error);

export const resetErrors = createAction(RESET_ERRORS, () => ({}));

export const resetApplicationState = createAction(RESET_APPLICATION_STATE);
